<mat-toolbar color="primary">
  <mat-toolbar-row>
    <span>{{ 'components.decision-table.new-decision-table.compile-proposal.import-team-members-from-chart' | translate}}</span>
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" (click)="closeDialogue()"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>
@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}
@if (dataSource?.data?.length > 0 && !loading) {
  <div class="container my-5">
    <table mat-table #outerSort="matSort" [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
      @for (column of columnsToDisplay; track column) {
        <ng-container matColumnDef="{{column}}">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ ('generic.' + column) | translate }} </th>
          <td mat-cell *matCellDef="let element">
            @if (column !== 'action' && column !== 'created_at') {
              <span>{{element[column]}}</span>
            }
            @if (column === 'action') {
              <div>
                <button  mat-button color="primary" [disableRipple]="true"> {{'tooltip.show' | translate}}</button>
                <button mat-button color="primary" [disableRipple]="true" (click)="importOrganizationUsers(element)"> {{'tooltip.add' | translate}}</button>
              </div>
            }
            @if (column === 'created_at') {
              <div>
                {{ element[column] | date :'shortDate' }}
              </div>
            }
          </td>
        </ng-container>
      }
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
          @if (element.organization_users?.data.length) {
            <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
              @if (expandedElement) {
                <div class="inner-table mat-elevation-z8">
                  <!--            <mat-form-field>
                  <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                </mat-form-field>-->
                <table #innerTables mat-table #innerSort="matSort" [dataSource]="element.organization_users" matSort>
                  @for (innerColumn of innerDisplayedColumns; track innerColumn) {
                    <ng-container matColumnDef="{{innerColumn}}">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ ('generic.' + innerColumn) | translate }} </th>
                      <td mat-cell *matCellDef="let element"> {{element[innerColumn]}} </td>
                    </ng-container>
                  }
                  <tr mat-header-row *matHeaderRowDef="innerDisplayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: innerDisplayedColumns;"></tr>
                </table>
              </div>
            }
          </div>
        }
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" [class.example-element-row]="element.organization_users?.data.length"
      [class.example-expanded-row]="expandedElement === element" (click)="toggleRow(element)">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
  </table>
</div>
}
@if (dataSource?.data?.length == 0 && !loading) {
  <div class="row justify-content-center my-5">
    {{ "modals.import-organization-charts.no-results" | translate }}
  </div>
}
